import styled from 'styled-components';

import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';

export const TutorialStepContent = styled(SBHorizontal)`
  height: 100%;
  padding: var(--triple-unit);
  flex-wrap: wrap-reverse;
  min-width: min(calc(var(--100vw) - var(--quadruple-unit)), 400px);
  gap: var(--quadruple-unit);
`;

export const TutorialStepTextContent = styled(Vertical)`
  flex: 1 0 min-content;
`;

export const TutorialStepAsset = styled(Vertical)`
  flex: 1 0 300px;
`;
